
// import Vue from 'vue'
import { Component, Prop, Watch } from "vue-property-decorator";
import baseUserContextPage from "../baseUserContextComponent";
import axios from "axios";
import { SupportRequestModel } from "../../models/SupportRequestModel";
var Qs = require("qs");

@Component({})
export default class assistenzaForm extends baseUserContextPage {
    firstname: string = "";
    lastname: string = "";
    company: string = "";
    email: string = "";
    message: string = "";
    privacy: boolean = true;
    marketing: boolean = false;
    myreason: string = "";
    @Prop({ default: () => "" })
    reason: string;

    sku: string = null;
    name: string = null;

    beforeMount() {
        this.resetForm();
    }
    onSubmit(e) {
        e.preventDefault();

        var self = this;

        let data: SupportRequestModel = {
            firstname: self.firstname,
            lastname: self.lastname,
            email: self.email,
            company: self.company,

            marketing: self.marketing,
            privacy: self.privacy,

            message: self.message,
            myreason: self.myreason
        };

        this.$emit("onSendSUpportRequest", true);

        axios
            .post<boolean>(`/customer/support`, data)
            .then((res) => {
                console.log(res);
                if (res && res.data) {
                    self.resetForm();
                    self.$notify({
                        title: "",
                        text: "Email di supporto inviata correttamente",
                        type: "info",
                        group: "generic"
                    });
                }

                self.$emit("onSendSUpportRequest", false);
            })
            .catch((error) => {
                console.error(error);

                if (error && error.response && error.response.data && error.response.data.length) {
                    // for (var i = 0; i < error.response.data.length; i++) {
                    //     let err = error.response.data[i];

                    //     self.$notify({
                    //         title: "ATTENZIONE",
                    //         text: err.text,
                    //         type: "error",
                    //         group: "msg",
					// 		duration: 10000
                    //     });
                    // }
                } else {
					self.$notify({
						title: "ERRORE",
						text: "Si è verificato un errore nell'invio dell'email di supporto",
						type: "error",
						group: "msg",
						duration: 10000
					});
                }

                self.$emit("onSendSUpportRequest", false);
            });
    }
    resetForm() {
        var instance = this;

        if (instance.getUser) {
            instance.firstname = instance.getUser.firstName;
            instance.lastname = instance.getUser.lastName;
            instance.email = instance.getUser.emailAddress;

            if (instance.getCurrentCustomer && instance.getCurrentCustomer.type == "Company") {
                instance.company = instance.getCurrentCustomer.company;
            }
        }

        instance.sku = <string>instance.$route.query.sku;
        instance.name = <string>instance.$route.query.name;
        instance.myreason = instance.reason;
        instance.message = "";
        // this.firstname = "";
        // this.lastname = "";
        // this.company = "";
        // this.email = "";
        // // this.reason = "";

        // this.myreason = "";
        // this.message = "";
        // this.privacy = true;
        // this.marketing = false;
        // this.sku = null;
        // this.name = null;
    }
}
